import React from 'react';
import memoize from 'memoize-one';
import { BasicDropdown, Icon } from '../../components';

const massActions = memoize((handleClick, permissions, disabled, rowsAmount) => {
  const actions = () => {
    const authorizedActions = [];

    authorizedActions.push({
      icon: <Icon icon="close" height="16px" width="16px" style={{ marginRight: 5 }} />,
      key: 'close',
      props: {
        onClick: () => handleClick('massive_close'),
        disabled: disabled || !permissions.manage
      },
      title: 'Cerrar Mes'
    });

    authorizedActions.push({
      icon: <Icon icon="trash" height="16px" width="16px" style={{ marginRight: 5 }} />,
      key: 'destroy',
      props: {
        onClick: () => handleClick('massive_destroy'),
        disabled: disabled || !permissions.manage
      },
      title: 'Eliminar'
    });

    authorizedActions.push({
      icon: <Icon icon="download-2" height="16px" width="16px" style={{ marginRight: 5 }} />,
      key: 'download',
      props: {
        onClick: () => handleClick('export'),
        disabled: rowsAmount === 0
      },
      title: 'Descargar'
    });

    return authorizedActions;
  };

  return (
    <div className="mb-4" style={{ display: 'flex', flexDirection: 'row' }}>
      <BasicDropdown
        block
        items={actions()}
        noArrow
        right
        titleDrop={
          <span className="align-middle">
            Acciones Masivas <Icon icon="ellipsis-vertical" height="20px" width="20px" />
          </span>
        }
        variant="outline-primary"
      />
    </div>
  );
});

export default massActions;
